export var getAutoOrScaleIndent = function getAutoOrScaleIndent(indent, scaleIndent) {
  if (typeof indent === 'string') {
    return indent;
  }
  if (typeof indent === 'number' && indent > -1 && indent < 1) {
    return "".concat(100 * indent, "%");
  }
  if (typeof indent === 'number' && (indent >= 1 || indent <= -1)) {
    return "".concat(indent * scaleIndent, "px");
  }
  return indent;
};
//# sourceMappingURL=utils.js.map